import shopDetailOtherDish from './oherDish'
import shopDetailOtherEmail from './oherEmail'
import shopDetailOtherBankflow from './oherBankflow'
import shopDetailOtherExtra from './oherExtra'
import baseDetail from './baseDetail'
import outputResult from './marketCalculator'

export default {
  shopDetailOtherDish,
  shopDetailOtherEmail,
  shopDetailOtherBankflow,
  shopDetailOtherExtra,
  baseDetail, // 基础信息
  outputResult, // 计算结果
}
